import { useState, useEffect } from 'react'


const useGetCombSelect = (url, routes) => {

    const [dataComb, setData] = useState([])

    useEffect(() => {

        const fetchResource = async () => {

            console.log(`${url}${routes}`)
            try {
                let res = await fetch(`${url}${routes}`)
                let data = await res.json()


                if (res.status === 200) {

                    setData(data)

                } else {
                    setData([])
                }

            } catch (error) {

                setData([])
            }

        }

        fetchResource()
    }, [])

    return dataComb
}

export default useGetCombSelect
